var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDefaultPortfolioManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01251 18.475V4.02502H1.01251V18.4625C1.01251 19.2875 1.68751 19.9625 2.51251 19.9625L22.9875 19.9125V18.9125L2.51251 18.9625C2.23751 18.975 2.01251 18.75 2.01251 18.475ZM22.4875 4.02502H19.2625V5.02502H21.275L13.65 12.65L11.0625 10.0625C10.8625 9.86252 10.55 9.86252 10.35 10.0625L3.37501 17.05L4.08751 17.7625L10.7125 11.1375L13.3 13.725C13.5 13.925 13.8125 13.925 14.0125 13.725L22 5.73752V7.75002H23V4.52502C22.9875 4.25002 22.7625 4.02502 22.4875 4.02502Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDefaultPortfolioManagement);
export default __webpack_public_path__ + "static/media/home-default-portfolio-management.b8d2d70bbaad99d01a21c10fef3795a9.svg";
export { ForwardRef as ReactComponent };